export const IS_PROD = () =>
  process.env.ENVIRONMENT?.toLowerCase() === 'production' ||
  process.env.APP_ENVIRONMENT?.toLowerCase() === 'production';

const isReactNative = () => {
  try {
    return typeof global !== 'undefined' && global.navigator?.product === 'ReactNative';
  } catch {
    return false;
  }
};

export const isDevelopment = () => {
  try {
    return (globalThis as any).__DEV__ ?? false;
  } catch {
    return false;
  }
};

export const DEV_LOGS_ENABLED = () => {
  if (isReactNative()) {
    return isDevelopment();
  }

  return [process.env.DEV_LOGS_ENABLED, process.env.NEXT_PUBLIC_DEV_LOGS_ENABLED].includes('true');
};

export const ONE_SECOND_MS = 1000;
export const ONE_MINUTE_MS = ONE_SECOND_MS * 60;
/** Time for the token to be expired - should be in sync with what back-end defined */
export const TOKEN_TTL = ONE_MINUTE_MS * 15;
/** Time to disconnect the user if no activity is detected */
export const TIME_UNTIL_DISCONNECTION_MS = TOKEN_TTL;
/** Time before token expiration (in ms) to consider it about to expire and trigger a refresh */
export const TOKEN_EXPIRATION_THRESHOLD_MS = ONE_MINUTE_MS * 5;
/** Time interval in which the token will be automatically refreshed in background */
export const TOKEN_REFRESH_INTERVAL_MS = TOKEN_TTL - ONE_MINUTE_MS;
